import { PortfolioIdUtil } from '@ddt-web/portfolio-data';
import { PartnerConstants } from '@ddt-web/user-data';
import * as isEmpty from 'lodash/isEmpty';


export class PortfolioResolverUtil {

	// Gets user portfolios and models. Filters out partner portfolios and rebalance portfolios
	public static extractInternalPortfolioIds(ids: any[]): any[] {
		return ids.filter(id => !id.includes(
			PartnerConstants.PARTNER.PARTNER_IDENTIFIER) &&
			!id.includes(PartnerConstants.PARTNER.EXT_IDENTIFIER) &&
			!id.includes('rebalance-') && !id.includes('latest-'));
	}

	// Gets user portfolios and models. Filters out partner portfolios and rebalance portfolios
	public static extractExternalPortfolioIds(ids: any[]): any[] {
		return ids.filter(id => id.includes(PartnerConstants.PARTNER.EXT_IDENTIFIER));
	}

	// Gets partner portfolios
	public static extractPartnerPortfolioIds(ids: any[]): any[] {
		return ids.filter(id => id.includes(PartnerConstants.PARTNER.PARTNER_IDENTIFIER));
	}

	public static isPortfoliosSuccessfullyLoaded(portfolioIds: any[], config: any, associatedPortfolios: any): boolean {
		const portfoliosMissingData = portfolioIds.filter(id => {
			if (PortfolioIdUtil.isModel(id)) {
				return !config?.entities?.[id] || !associatedPortfolios?.entities?.[id];
			} else {
				return !associatedPortfolios?.entities?.[id];
			}
		});
		const hasFailedPortfolio = portfolioIds.some(id => associatedPortfolios?.entities?.[id]?.errorCode || associatedPortfolios?.entities?.[id]?.error);

		return isEmpty(portfoliosMissingData) && !hasFailedPortfolio;
	}

	public static isSavedModelPortfoliosSuccessfullyLoaded(portfolioIds: any[], associatedPortfolios: any): boolean {
		const portfoliosMissingData = portfolioIds.filter(id => !associatedPortfolios?.entities?.[id]);
		const hasFailedPortfolio = portfolioIds.some(id => associatedPortfolios?.entities?.[id]?.errorCode || associatedPortfolios?.entities?.[id]?.error);

		return isEmpty(portfoliosMissingData) && !hasFailedPortfolio;
	}
}
